module.exports = __webpack_public_path__ + "static/img/user-icon.fb1d6f7a.png";